import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCheckbox,{attrs:{"label":"Filter Hospital/Clinic by Location"},on:{"change":function($event){return _vm.handleChangeFilterFromHosp($event)}},model:{value:(_vm.filterHosp),callback:function ($$v) {_vm.filterHosp=$$v},expression:"filterHosp"}})
}
var staticRenderFns = []

export { render, staticRenderFns }